import * as React from "react";
import "./loaderInfinite.scss";

/** Component for displaying loading component. */
const LoaderInfinite = (): JSX.Element => {
    return (
        <div className="stage">
            <div className="dot-flashing"></div>
        </div>
    );
};

export default LoaderInfinite;